var unitPrice = "{{ pricePerUnit }} styck";
var unitsCount = "{{ unitsCount }} stycken";
var unitCount = "{{ unitsCount }} styck";
var unitPriceWithQuantity = "{{ pricePerUnit }} styck / {{ unitsCount }} stycken";
var vatInclusive = "Inkl. moms";
var vatExclusive = "Exkl. moms";
var excludeShipping = "Exkl. {{ shipping }}";
var includeShipping = "Inkl. {{ shipping }}";
var shipping = "leverans";
var vatAndShipping = {
	includeVatExcludeShipping: "Inkl. moms, exkl. {{ shipping }}",
	excludeVatIncludeShipping: "Exkl. moms, inkl. {{ shipping }}",
	includeVatIncludeShipping: "Inkl. moms, inkl. {{ shipping }}",
	excludeVatExcludeShipping: "Exkl. moms, exkl. {{ shipping }}"
};
var priceSummary = "Prissammanställning";
var priceSummaryInfoIcon = "Symbol för information om prissammanställning";
var priceSummaryModal = "Modalt fönster med prissammanställning";
var priceSummaryCloseModal = "Stäng modalt fönster med prissammanställning";
var priceSummaryTermsAndConditions = "*För varje beställning skapas en unik duk eller kudde, och utrustningen anpassas för att trycka din design. ";
var priceSummaryBasePrice = "Grundpris";
var priceSummarySetupFee = "*Uppläggningsavgift";
var priceSummarySubtotal = "Delsumma";
var differentialPrice = {
	included: "Ingår",
	forUnits: "{{ differentialPrice }} för {{ quantity }} stycken",
	forUnit: "{{ differentialPrice }} för {{ quantity }} styck"
};
var priceFrom = "Från {{ price }}";
var volumeDiscount = "{{volumeDiscount}} % i volymrabatt";
var volumeDiscountPlusSale = "{{volumeDiscount}} % i volymrabatt + rea";
var rangePrice = "{{xx}}–{{yy}}";
var unitRangePrice = "{{rangePrice}} styck";
var originalPrice = "ursprungligt pris:";
var salePrice = "aktuellt försäljningspris:";
var setupFee = "{{ setupFee }} uppläggningsavgift tillkommer";
var noSetupFee = "Ingen uppläggningsavgift";
var vatAndSetupFee = {
	noVatInclSetup: "Inkl. {{ setupFee }} uppläggningsavgift",
	inclVatAndSetup: "Inkl. {{ setupFee }} uppläggningsavgift och moms",
	exclVatInclSetup: "Inkl. {{ setupFee }} uppläggningsavgift, exkl. moms",
	inclVatSetupInclShipping: "Inkl. {{ setupFee }} uppläggningsavgift och moms, inkl. {{ shipping }}",
	inclVatSetupExclShipping: "Inkl. {{ setupFee }} uppläggningsavgift och moms, exkl. {{ shipping }}",
	exclVatSetupInclShipping: "Inkl. {{ setupFee }} uppläggningsavgift, exkl. moms, inkl. {{ shipping }}",
	exclVatSetupExclShipping: "Inkl. {{ setupFee }} uppläggningsavgift, exkl. moms och {{ shipping }}"
};
var svse = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee
};

export { svse as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFrom, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
//# sourceMappingURL=ep-pricing-esm-localization-texts-sv-se.json.js.map
